import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BadgeCheck } from "lucide-react";
import { TEAM } from "../data/office";

export default function LawyerCarousel() {
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return undefined;
    const t = setInterval(() => setIdx((i) => (i + 1) % TEAM.length), 5000);
    return () => clearInterval(t);
  }, [paused]);

  const person = TEAM[idx];

  return (
    <div
      className="absolute inset-0 bg-navy-800"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      data-testid="hero-lawyer-carousel"
    >
      <AnimatePresence>
        <motion.img
          key={person.photo}
          src={person.photo}
          alt={`Advogada ${person.name}`}
          className="absolute inset-0 h-full w-full object-contain"
          initial={{ opacity: 0, scale: 1.03 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.9, ease: "easeInOut" }}
        />
      </AnimatePresence>
      <div className="absolute inset-0 bg-gradient-to-t from-navy-950/90 via-transparent to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-6">
        <AnimatePresence mode="wait">
          <motion.div
            key={person.name}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.4 }}
            data-testid="hero-lawyer-caption"
          >
            <p className="font-display text-2xl font-semibold text-cream">{person.name}</p>
            <p className="font-mono-meta mt-1 text-[11px] uppercase tracking-[0.25em] text-gold-400">
              {person.oab}
            </p>
          </motion.div>
        </AnimatePresence>
        <div className="mt-4 flex gap-1.5">
          {TEAM.map((p, i) => (
            <button
              key={p.name}
              data-testid={`hero-slide-${i}`}
              aria-label={`Ver ${p.name}`}
              onClick={() => setIdx(i)}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                i === idx ? "w-6 bg-gold-500" : "w-1.5 bg-cream/40 hover:bg-cream/70"
              }`}
            />
          ))}
        </div>
      </div>
      <div
        data-testid="hero-oab-verified"
        className="absolute bottom-4 right-4 flex items-center gap-1.5 rounded-full border border-gold-500/40 bg-navy-950/85 px-3 py-1.5 backdrop-blur-md"
      >
        <BadgeCheck className="h-3.5 w-3.5 text-gold-400" />
        <span className="font-mono-meta text-[10px] uppercase tracking-widest text-cream">
          OAB/MG · Verificada
        </span>
      </div>
    </div>
  );
}
